<script>
import MarkdownIt from 'markdown-it'
import DOMPurify from 'dompurify'
export default {
  name: "MarkdownRenderer",
  props: {
    source: { type: String, required: true},
    options: { type: Object, required: false}
  },
  data() {
    return {
      md: new MarkdownIt({ html: true, ...this.options }),
    }
  },
  mounted(){
    this.$el.querySelector('#content-container').innerHTML = this.content;
  },
  watch: {
    content(to) {
      this.$el.querySelector('#content-container').innerHTML = to;
    }
  },
  computed: {
    content() {
      const src = this.source;
      const rendered = this.md?.render(src);
      return DOMPurify.sanitize(rendered, {
        ADD_ATTR: ['style', 'alt', 'src', 'width', 'height'],
      });
    },
  },
}
</script>

<template>
  <div>
    <div id="content-container"></div>
  </div>
</template>

<style scoped>

</style>